import React, { useState } from 'react';
import Popup from 'reactjs-popup';

const ConfirmationModalTentative = ({ isOpen, onClose, onSave, onCancel, commentMandatory, placeHolderText }) => {
    const [comment, setComment] = useState("");

    const handleCommentChange = (e) => {
        setComment(e.target.value);
    };

    const handleSave = () => {
        if ((comment==="") && commentMandatory) alert("Please comment your decision.");
                                           else onSave(comment);  
    };

    return (
        <Popup
            open={isOpen}
            onClose={onClose}
            contentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                border: '1px solid #d9d7d7',
                borderRadius: '5px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
            }}
            overlayStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                zIndex: 1040,
            }}
        >
            <div className="modal-content" style={{ color: 'darkblue' }}>
                <h5 className='popupTitle'>Tentative</h5>
                <p className='popup-text'>
                    Are you sure you want to send a &quot;Tentative&quot; reply?
                </p>
                <div className="form-group">
                    <label htmlFor="comment" className='text-label'>Comment</label>
                    <textarea
                        id="comment"
                        rows="3"
                        placeholder={placeHolderText}
                        value={comment}
                        onChange={handleCommentChange}
                        className='form-control popup-textarea' />
                </div>

                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button
                        className="btn btn-cancel"
                        onClick={onCancel}>
                        CANCEL
                    </button>
                    <button
                        className="btn btn-save"
                        onClick={handleSave}>
                        SAVE
                    </button>
                </div>
            </div>
        </Popup>
    );
};

export default ConfirmationModalTentative;